const BASE_URL = '/api/curation/'

export function useCuration() {
  const { fetchGet, fetchPost } = useCustomFetch()
  function getCuration(id: string): Promise<Curation> {
    return fetchGet(BASE_URL + id)
  }

  function deleteCuration(c: Curation): Promise<JpsResponse> {
    return fetchPost(BASE_URL + c.id + '/delete')
  }

  function createCuration(cur: Curation): Promise<Curation> {
    return fetchPost(BASE_URL + 'create', cur)
  }

  function updateCuration(cur: Curation): Promise<Curation> {
    return fetchPost(BASE_URL + 'update', cur)
  }

  function searchCuration(query: SearchQuery): Promise<SearchResult<Curation>> {
    return fetchGet(BASE_URL + 'search' + toSearchQueryString(query))
  }

  return {
    getCuration,
    deleteCuration,
    createCuration,
    updateCuration,
    searchCuration,
  }
}
